import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageMain from "../../containers/shared/PageMain";
import PageHeader from "../../components/shared/PageHeader";
import MainContent from "../../containers/shared/MainContent";
import Loading from "../../components/shared/Loading";
import useUser from "../../components/helpers/useUser";
import { useEffect, useState } from "react";
import apiClient from "../../components/utils/apiClient";
import { useTranslation } from "react-i18next";


const HomePage = () => {
  const {t} = useTranslation();
  useDocumentTitle(t('nav.home'));
  const pageTitle = {title: t('nav.home')};
  const [user,setUser] = useUser();
  const [vendor,setVendor] = useState(null);

  const getUserData = async () => {
    try {
      const response = await apiClient.get(`vendors/${user?._id}`);
      if(response?.data) {
        setVendor(response?.data);
      } else {

      }
    } catch(err) {}
  }

  useEffect(()=>{
      if(user && user?._id) {
          getUserData();
      }
  },[user])
    
  return (
    <div>
      <PageHeader isColored pageTitle={pageTitle} />
      <PageMain>
        {/* <div className="absolute top-0 left-0 w-full h-full bg-grey-50 z-0"></div> */}
        <MainContent>
          {vendor && <>
          <div className="flex flex-wrap gap-x-[24px] gap-y-[40px] pt-[50px]">
            <div className="relative rounded-[8px] h-[138px] ltr:h-[160px] w-full lg:w-[calc(25%-18px)] bg-[#F5F2EC] font-[600] text-[16px] lg:text-[20px] text-black p-[20px] lg:p-[30px]">
              <span className="bg-[#F5F2EC] rounded-[8px] w-[56px] h-[56px] absolute top-[-28px] rtl:right-[15px] ltr:left-[15px] z-[1] !bg-center !bg-no-repeat" style={{backgroundImage:"url('/assets/images/home-users.svg')"}}></span>
              <p className="text-[24px] lg:text-[32px]">{vendor?.workersCount || 0}</p>
              <div>{t('dashboard.workersCount')}</div>
            </div>
            <div className="relative rounded-[8px] h-[138px] ltr:h-[160px] w-full lg:w-[calc(25%-18px)] bg-[#EAEFF2] font-[600] text-[16px] lg:text-[20px] text-black p-[20px] lg:p-[30px]">
              <span className="bg-[#EAEFF2] rounded-[8px] w-[56px] h-[56px] absolute top-[-28px] rtl:right-[15px] ltr:left-[15px] z-[1] !bg-center !bg-no-repeat" style={{backgroundImage:"url('/assets/images/home-wallet.svg')"}}></span>
              <p className="text-[24px] lg:text-[32px]">
                {vendor?.credits?.toFixed(2) || '0.00'}
                <span className="w-[24px] h-[26px] inline-block ms-[5px]" style={{background:"url('/assets/images/home-sar.svg')"}}></span>
              </p>
              <div>{t('dashboard.walletBalance')}</div>
            </div>
            <div className="relative rounded-[8px] h-[138px] ltr:h-[160px] w-full lg:w-[calc(25%-18px)] bg-[#EDF2F0] font-[600] text-[16px] lg:text-[20px] text-black p-[20px] lg:p-[30px]">
              <span className="bg-[#EDF2F0] rounded-[8px] w-[56px] h-[56px] absolute top-[-28px] rtl:right-[15px] ltr:left-[15px] z-[1] !bg-center !bg-no-repeat" style={{backgroundImage:"url('/assets/images/home-charge.svg')"}}></span>
              <p className="text-[24px] lg:text-[32px]">
                {vendor?.totalCreditCharge?.toFixed(2) || '0.00'}
                <span className="w-[24px] h-[26px] inline-block ms-[5px]" style={{background:"url('/assets/images/home-sar.svg')"}}></span>
              </p>
              <div>{t('dashboard.chargeAmount')}</div>
            </div>
            <div className="relative rounded-[8px] h-[138px] ltr:h-[160px] w-full lg:w-[calc(25%-18px)] bg-[#F0ECF5] font-[600] text-[16px] lg:text-[20px] text-black p-[20px] lg:p-[30px]">
              <span className="bg-[#F0ECF5] rounded-[8px] w-[56px] h-[56px] absolute top-[-28px] rtl:right-[15px] ltr:left-[15px] z-[1] !bg-center !bg-no-repeat" style={{backgroundImage:"url('/assets/images/home-income.svg')"}}></span>
              <p className="text-[24px] lg:text-[32px]">
                {vendor?.totalWorkersWage?.toFixed(2) || '0.00'}
                <span className="w-[24px] h-[26px] inline-block ms-[5px]" style={{background:"url('/assets/images/home-sar.svg')"}}></span>
              </p>
              <div>{t('dashboard.workersIncome')}</div>
            </div>
          </div>
          </>}

          <br />
      </MainContent>
      </PageMain>

      {!vendor && <Loading showLoading={true} />}
    </div>
  );
};

export default HomePage;
